import React, { memo } from 'react'

const Buuton = ({text, className, ...props}) => {
  return (
    <button 
      className={`button ${className ?? ''}`}
      {...props}
    >
        {text}
    </button>
  )
}

export default memo(Buuton)